/*
---
description: FED Process
authors:
- David Chan CK
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var Gv = {
	env: 'pro',					// Environment [dev = development, pro = production]
	page: null,					// Page instance, globally referrable.
	hidden: 'hidden',
	cloak: 'cloak',
	ge: new Events(),		// Global event handler
	url:								 // Page Urls
	{
		ext: '/j/y/b/ext'
	}
};

// Define a convenient method to escape special characters from regexp
RegExp.escape = function(text) {
  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
};

// Override Request headers from Mootools
// Append the CSRF Token on every xhr calls from mootools
var metaCRSF = $$('meta[name="csrf-token"]').length > 0 ? $$('meta[name="csrf-token"]')[0].getProperty('content') : undefined;
var csrfToken = metaCRSF || Cookie.read('CSRF-Token');
Object.merge(Request.prototype.options.headers, {
	'X-CSRF-Token' : csrfToken
});

// Monitor loading and execution time
crMonitor.end('loadingTime');
crMonitor.start('executionTime');

// Init the user infos
crUser.init();

// Init the chat
crChat.init();

// Init the analytics hook
crAnalytics.init();

// Init the crypto
crCrypto.init();

// Init the crypto
crRating.init();
